import React, { useContext } from "react";
import { calculateZoom, calculate_distance } from "../dealer-locator/utils.js"
import GoogleMapReact from 'google-map-react';
import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";
import { translate } from "../../../utility/strings.js";

const MapItem = ({style}) => {
  switch(style){
    case "from":
      return <div className="shipment-map__icon">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
              <circle  cx="7" cy="7.3" r="4.5" style="fill:var(--horizon-blue)"/>
              <path d="M13.7,6.9c.1,1.7-.4,3.2-1.3,4.4l-1.2,1.8-2.9,4.6c-.6.9-1.8.9-2.4,0l-2.4-3.9c-.5-.8-1-1.5-1.6-2.2-.9-1.1-1.5-2.6-1.5-4.2C.4,3.6,3.7.5,7.6.8c3.2.1,5.8,2.8,6.1,6.1ZM7,11.5c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.1-4.2-4.1-4.2,1.8-4.2,4.1,1.9,4.2,4.2,4.2Z" style="fill-rule: evenodd; clip-rule: evenodd;"/>
              <path d="M5.1,4.9h3.3l1,1v3l-1,1h-3.3v-4.9ZM8.1,8.8c0,0,0,0,.1-.1,0,0,0-.1,0-.2v-2.3c0,0,0-.1,0-.2,0,0,0,0-.1-.1,0,0-.1,0-.2,0h-1.7v2.9h1.7c0,0,.1,0,.2,0Z" style="fill-rule: evenodd; clip-rule: evenodd;"/>
            </svg>
          </div>;
    default:
      return <div className="shipment-map__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 19" xmlSpace="preserve">
              <circle cx="7" cy="7.3" r="4.5" style="fill: var(--light-grey);"></circle>
              <path d="M13.7 6.9c.1 1.7-.4 3.2-1.3 4.4l-1.2 1.8-2.9 4.6c-.6.9-1.8.9-2.4 0l-2.4-3.9c-.5-.8-1-1.5-1.6-2.2C1 10.5.4 9 .4 7.4.4 3.6 3.7.5 7.6.8c3.2.1 5.8 2.8 6.1 6.1zM7 11.5c2.3 0 4.2-1.9 4.2-4.2S9.3 3.2 7 3.2C4.7 3.2 2.8 5 2.8 7.3s1.9 4.2 4.2 4.2z" style="fill-rule: evenodd; clip-rule: evenodd;"></path>
            </svg>
          </div>;
  }
}

const ShipmentMap = () => {

  let { shipment, loading, googleApiKey } = useContext(ShipmentContext);

  const onBoundsChange = (center, zoom, bounds, marginBounds) => {
    console.log(center, zoom, bounds, marginBounds);
  }
  
  let from, to, zoom;
  const center = {
    lat: 33.3483672,
    lng: -112.8840237
  }

  if(!shipment.locations?.from?.latitude || 
      !shipment.locations?.to?.latitude || 
      !shipment.locations?.from?.longitude ||
      !shipment.locations?.to?.longitude){
      return null;
  }

  if(shipment && shipment.locations){
    from = shipment.locations.from;
    to = shipment.locations.to;

    center.lat = (from.latitude + to.latitude) / 2;
    center.lng = (from.longitude + to.longitude) / 2;

    var height = window.innerHeight * .5;
    var width = window.innerWidth;

    const northPoint = {
      lat: Math.max(from.latitude, to.latitude),
      lng: Math.min(from.longitude, to.longitude)
    }
    const southPoint = {
      lat: Math.min(from.latitude, to.latitude),
      lng: Math.min(from.longitude, to.longitude)
    }
    const eastPoint = {
      lat: Math.min(from.latitude, to.latitude),
      lng: Math.max(from.longitude, to.longitude)
    }

    const widthInMeters = calculate_distance(southPoint, eastPoint.lat, eastPoint.lng);
    const heightInMeters = calculate_distance(southPoint, northPoint.lat, northPoint.lng);

    if(widthInMeters / heightInMeters > width / height){
      zoom = calculateZoom(width, 100, center.lat, widthInMeters);
    }else{
      zoom = calculateZoom(height, 100, center.lat, heightInMeters);
    }

  }

  return (<>
    {!loading && shipment && from && to ?
      <div className="shipment-map my-10">
        <h2 className="h4 mb-4 text-center">{translate("shipment_tracking.order_tracker", "Order Tracker")}</h2>

        <div className="shipment-map__container">
          <GoogleMapReact
            bootstrapURLKeys={{
              libraries: ['places'],
              key: googleApiKey
            }}
            center={center}
            zoom={zoom}
            hoverDistance={20}
            options={{
              gestureHandling: "greedy",
              fullscreenControl: false,
              zoomControl: false,
              clickableIcons: false
            }}
            onChange={onBoundsChange}
          >
            <MapItem lat={from.latitude} lng={from.longitude} style="from" />
            <MapItem lat={to.latitude} lng={to.longitude} />
          </GoogleMapReact>
        </div>
      </div>
    : null }
    </>
  );

}

export default ShipmentMap;
